/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplierOrganizationDto } from './SupplierOrganizationDto';
import {
    SupplierOrganizationDtoFromJSON,
    SupplierOrganizationDtoFromJSONTyped,
    SupplierOrganizationDtoToJSON,
} from './SupplierOrganizationDto';

/**
 * 
 * @export
 * @interface SupplierOrganizationsResponseDto
 */
export interface SupplierOrganizationsResponseDto {
    /**
     * Array of supplier organizations
     * @type {Array<SupplierOrganizationDto>}
     * @memberof SupplierOrganizationsResponseDto
     */
    data: Array<SupplierOrganizationDto>;
    /**
     * Number of organizations returned in current query
     * @type {number}
     * @memberof SupplierOrganizationsResponseDto
     */
    queryCount: number;
    /**
     * Total number of organizations matching filters
     * @type {number}
     * @memberof SupplierOrganizationsResponseDto
     */
    totalCount: number;
    /**
     * Total number of pages available
     * @type {number}
     * @memberof SupplierOrganizationsResponseDto
     */
    totalPages: number;
}

/**
 * Check if a given object implements the SupplierOrganizationsResponseDto interface.
 */
export function instanceOfSupplierOrganizationsResponseDto(value: object): value is SupplierOrganizationsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('queryCount' in value) || value['queryCount'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function SupplierOrganizationsResponseDtoFromJSON(json: any): SupplierOrganizationsResponseDto {
    return SupplierOrganizationsResponseDtoFromJSONTyped(json, false);
}

export function SupplierOrganizationsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierOrganizationsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SupplierOrganizationDtoFromJSON)),
        'queryCount': json['queryCount'],
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
    };
}

export function SupplierOrganizationsResponseDtoToJSON(value?: SupplierOrganizationsResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(SupplierOrganizationDtoToJSON)),
        'queryCount': value['queryCount'],
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
    };
}

